import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import { FormHelperText, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Form, Input } from "reactstrap";
import { FormGroup, TextField } from "@material-ui/core";
import Select from "react-select";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import "./ProjectAllocation.css";
import {
  PROJECTCREATE,
} from "../../../../src/redux/CommonInitialsate";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import Allocationaccesstabel from "./Allocationaccesstabel";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col } from "reactstrap";
import { Button } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
// import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
}));
export default function ProjectManageAccess({
  openAllocForm,
  setOpenAllocForm,
  EmpId,
  projectdetails,
  handleClose,
  ProAllocateModal,
  employee,
  setmanageaccess,
  setacccessm,
  accessm,
  manageaccess,
  selectedproject
  
}) {

  
  // Custom style part
  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: "14px",
      borderRadius: 8,
      // match with the menu
      border: state.isFocused
        ? "2px solid rgb(82, 80, 229)"
        : "1px solid rgba(0, 0, 0, 0.10)",
      borderRadius: 8,
      boxShadow: state.isFocused ? null : null,
      "&:hover": {},
    }),
    menu: (base) => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  // end

  useEffect(() => {
    if (selectedproject !== Values.ProjectCode) {
      setValues((prevValues) => ({
        ...prevValues,
        ProjectCode: selectedproject,
      }));
      handleInputChange({ value: selectedproject }, "ProjectCode"); 
    }
    
    axios
      .get("agilesaas_roles_master")
      .then((res) => setManagers(res.data))
      .catch((err) => {
        console.log(err);
      });
  }, [ProAllocateModal]);
  // gobol decleration
    const dispatch = useDispatch();
  const newDate = new Date();
  const username = localStorage.getItem("username") == undefined ? "" : JSON.parse(localStorage.getItem("username"))

  let id =
    localStorage.getItem("clientid") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("clientid"));
  let createdby =
    localStorage.getItem("Empdetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("Empdetails"));
  let clientid =
    localStorage.getItem("clientid") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("clientid"));
  let clientdetails =
    localStorage.getItem("clientdetails") == "undefined"
      ? ""
      : JSON.parse(localStorage.getItem("clientdetails"));
  const intialValue = {
    TeamMemberId: [],
    ProjectCode: 0,
    ProjectStartDate: new Date(),
    ProjectEndDate: new Date(newDate.setMonth(newDate.getMonth() + 6)),
    ManagerId: createdby[0]?.ClientUserId,
    AllocPercentage: "100",
    ProjectRole: {
      RoleGroupId: "1",
      RoleCode: "SM",
      RoleName:  "Scrum Master",
    },
    MappedBy: createdby[0]?.ClientUserId,
    MappedByDetails: {
      ContactName: username,
      ContactDesignation: clientdetails[0]?.RoleDetails?.RoleCode,
      ContactEmail: clientdetails[0]?.UserDetails?.Email,
      ContactPhone: clientdetails[0]?.OrgDetails?.ContactPhone,
    },
    IsCurrent: "Y",
    Status: null,
    ClientId: clientid,
  };
  // end
  // usestate decleartion
  const [Projroledata, setProjroledata] = useState([]);
  const [managers, setManagers] = useState(null);
  const [Refesh, setRefesh] = useState(true);
  const [Values, setValues] = useState(intialValue);
  const [visible, setVisible] = useState(false);
  const [allocatedEmployee, setAllocatedEmployee] = useState(null);
  const [deallocateddata, setdealloacteddata] = useState(null);
  const [edit, setEdit] = useState(false);
  const [Errors, setErrors] = useState({});
  const [projectMappingId, setProjectMappingId] = useState("");
  const [checkSubmit, setSubmitCheck] = useState(false);
  const [test, setTest] = useState(null);
  //  usestate decleration end
  //details from localstorage
  const projectname = projectdetails
    ?.filter((e) => e.ProjectId === Values.ProjectCode)
    ?.map((f) => f.ProjectName);
  const allocatedemp = employee
    ?.filter((r) => r.UserId === Values.TeamMemberId)
    ?.map((d) => d.UserDetails.Email);

  const userorg = clientdetails[0]?.OrgDetails;

  const managerdata = managers?.map((e) => e.RoleName);
  let managerdropdown = managers?.filter(
    (e) => e.RoleCode != "BO" && e.RoleCode != "PO"
  );
  const {dateformat } = useSelector(
    (state) => state.user
  );
  const managerdrop = managerdata?.map((man) => {
    return {
      value: man.RoleGroupId,
      label: man.RoleName,
    };
  });
  const projectOption =
    projectdetails?.length == 0
      ? []
      : projectdetails?.map((pro) => {
        return {
          value: pro.ProjectId,
          label: pro.ProjectName,
        };
      });

      const employeeOption = employee?.length == 0
      ? []
      : employee
      ?.filter((emp) => {
       
        return Projroledata.some(
          (proj) => proj.TeamMemberId === emp.UserId && proj.ProjectRole.RoleCode === "SM"
        );
      })
      ?.map((emp) => {
        return {
          value: emp.UserId,
          label: emp.UserDetails.Firstname + " " + emp.UserDetails.Lastname,
          pertec: Projroledata.filter(
            (proj) => proj.TeamMemberId === emp.UserId
          )
            .map((proj) => parseInt(proj.AllocPercentage, 10))
            .reduce((acc, val) => acc + val, 0),
        };
      });
    
  
        
  const roleOption =
    managerdropdown?.length == 0
      ? []
      : managerdropdown?.map((man) => {
        return {
          value: man.RoleGroupId,
          label: man.RoleName,
          RoleCode: man.RoleCode,
        };
      });
  // functions

  
  const resetForm = () => {
    setValues({ ...intialValue, TeamMemberId: Values.TeamMemberId });
    setErrors({});
  };
  
  const DateInputChange = (e, vaildateOnChange = false) => {
    setValues({
      ...Values,
      [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
    });
  };
  const convertToPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  const handleInputChange = (e, name) => {
    if (name === "ProjectCode") {
      const projectCode = e.value; 
      setValues({
        ...Values,
        ProjectCode: projectCode,
      });
      loadData(Values.TeamMemberId, projectCode); // Pass the project code to loadData
    } else if (name === "TeamMemberId") {
      let value = Array.isArray(e)
        ? e.map((x) => x.value)
        : [];
      setValues({
        ...Values,
        [name]: value,
      });
      loadData(value, Values.ProjectCode); // Update data based on team members and project code
    } else if (name === "AllocPercentage") {
      setValues({
        ...Values,
        [name]: e.target.value,
      });
    } else {
      setValues({
        ...Values,
        [name]: e.value,
      });
    }
  };
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const closeIconHandler = () => {
    // setOpenAllocForm(false);
    setVisible(false);
    resetForm();
  };
  if (Refesh) {
    axios.get(`agilesaas_project_mapping?ClientId=eq.${clientid}&IsCurrent=eq.Y`).then((res) => {
      console.log(res.data,"projroledat");
      
      setProjroledata(res.data);
      setRefesh(false);
    });
  }
  const loadData = async (teamMemberIds, projectCode) => {
    
  
    try {
 
      const response = await axios.get(
        `agilesaas_project_mapping?ClientId=eq.${clientid}&IsCurrent=eq.Y`
      );
  

      const projectMappingData = response.data;
  

      let filteredProjectRoleData;
  
      if (teamMemberIds && teamMemberIds.length > 0) {
        filteredProjectRoleData = projectMappingData.filter((item) =>
          teamMemberIds.includes(item.TeamMemberId)
        );
      } else {
        filteredProjectRoleData = projectMappingData.filter(
          (item) => item.ProjectCode === projectCode
        );
      }
  

      setAllocatedEmployee(filteredProjectRoleData);
      setdealloacteddata(filteredProjectRoleData);
    } catch (error) {
      console.error("Error fetching project mapping data:", error);
    }
  };
  
  // Save Function
  function calculateRemainingAllocation(currentAllocation, newAllocation) {
    // Ensure currentAllocation is a number between 0 and 100
    currentAllocation = Math.min(
      Math.max(parseFloat(currentAllocation) || 0, 0),
      100
    );

    // Ensure newAllocation is a number between 0 and 100
    newAllocation = Math.min(Math.max(parseFloat(newAllocation) || 0, 0), 100);

    // Calculate remaining allocation
    let remainingAllocation = 100 - currentAllocation;

    // If newAllocation is greater than remainingAllocation, set it to remainingAllocation
    let allocatedPercentage = Math.min(newAllocation, remainingAllocation);

    return allocatedPercentage;
  }
  const addAllocationHandler = (e) => {
    e.preventDefault();
  
    if (!Values.TeamMemberId || Values.TeamMemberId.length === 0) {
      setErrors({ TeamMemberId: "Please select a Manager" });
      return;
    }
  
    if (!Values.ProjectCode) {
      setErrors({ ProjectCode: "Please select a project" });
      return;
    }
  
    if (
      moment(Values.ProjectEndDate).diff(moment(Values.ProjectStartDate), "days") <= 0
    ) {
      alert("Start date should be earlier than end date");
      return;
    }
  
    const alreadyAllocated = allocatedEmployee?.some(
      (allocation) =>
        allocation.TeamMemberId === Values.TeamMemberId[0] &&
        allocation.ProjectCode === Values.ProjectCode
    );
  
    if (alreadyAllocated) {
      setErrors({ TeamMemberId: "This manager already has access to this project." });
      return;
    }
  
    const PostArray = Values.TeamMemberId?.map((id) => ({
      ...Values,
      TeamMemberId: id,
      ProjectCode: Values.ProjectCode, 
    }));
    if (PostArray.length > 0) {
      setSubmitCheck(true);
      axios
        .post(
          "agilesaas_project_mapping",
          PostArray.filter((e) => e.AllocPercentage > 0)
        )
        .then((res) => {
          setSubmitCheck(false);
          toast.success(`Access to the project has been granted`, {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            draggable: true,
          });
  
          
          loadData(Values.TeamMemberId,Values.ProjectCode);
          setVisible(true);
          setRefesh(true);
          setValues({ ...Values, ProjectCode: 0 });
          setErrors({});
        })
        .catch(console.log);
    }
  };
  const closeaccess = () => {
   dispatch(PROJECTCREATE(false));
    setValues({ ...intialValue, TeamMemberId: [], ProjectCode: 0 });
    handleClose();
if(manageaccess){
   setmanageaccess(false) 
  }

if(accessm) {
  setacccessm(false) 
}

    setErrors({});
  };
  

  return (
    <div>
      {" "}
      <Row className="mb-4">
        <Col lg={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <label className="SprintlabelStyle">
            Managers Name
              <label className="createAlert">*</label>
            </label>
            <span className=" ml-1" style={{ paddingBottom: "12px" }}>
              {/* <Tooltip> */}
              <i
                style={{ cursor: "pointer" }}
                maxMenuHeight={142}
                className="fa fa-info-circle text-muted  "
                aria-label="info"
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              ></i>
              {/* <IconButton
                // style={{ fontSize: "small" }}
                aria-label="info"
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              >
                <InfoIcon fontSize="small" />
              </IconButton> */}

              {/* </Tooltip> */}
              <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                  paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
              >
                <Typography style={{ fontSize: "11px" }}>
                  Click on team member to add multiple team members
                </Typography>
              </Popover>
            </span>
          </div>

          <Select
            // styles={customStyles}
            // maxMenuHeight={80}
            style={{ width: "170px" }}
            maxMenuHeight={180}
            // labelId="demo-simple-select-outlined-label"
            // id="demo-simple-select-outlined"
            name="TeamMemberId"
            isMulti={true}
            isDisabled={edit}
            options={employeeOption}
            onChange={(e) => handleInputChange(e, "TeamMemberId")}
            error={Errors.TeamMemberId}
            helperText={Errors.TeamMemberId}
            value={
              Values.TeamMemberId
                ? employeeOption?.filter((e) =>
                  Values?.TeamMemberId?.includes(e.value)
                )
                : []
            }
            required
            native
          />
          {/* {console.log(
            employeeOption?.filter((item) =>
              Values.TeamMemberId.includes(item.TeamMemberId)
            ),
            "nandri3",
            employeeOption,
            Values.TeamMemberId
          )} */}
          <FormHelperText style={{ color: "red" }}>
            {Errors.TeamMemberId}
          </FormHelperText>
        </Col>
        {/* <Col lg={6}>
          <label className="SprintlabelStyle">
            Project Name
            <label className="createAlert">*</label>
          </label>{" "}
          <Select
            styles={customStyles}
            // style={{ width: "100px" }}
            maxMenuHeight={180}
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            name="ProjectCode"
            // value={Values.ProjectCode}
            options={projectOption}
            onChange={(e) => handleInputChange(e, "ProjectCode")}
            value={projectOption?.filter(
              (option) => option.value == Values?.ProjectCode
            )}
            error={Errors.ProjectCode}
            helperText={Errors.ProjectCode}
            required
            native
          />
          <FormHelperText style={{ color: "red" }}>
            {Errors.ProjectCode}
          </FormHelperText>
        </Col> */}
      </Row>
      {/* <Row className="mb-4">
        <Col lg={6}>
          <label className="SprintlabelStyle">
            Project Role
            <label className="createAlert">*</label>
          </label>
          <Select
            styles={customStyles}
            style={{ width: "170px" }}
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            name="RoleGroupId"
            maxMenuHeight={180}
            // value={Values.ProjectRole}
            options={roleOption}
            onChange={(e) => {
              setValues({
                ...Values,
                ProjectRole: {
                  RoleName: e.label,
                  RoleGroupId: e.value,
                  RoleCode: e.RoleCode,
                },
              });
            }}
            error={Errors.ProjectRole}
            helperText={Errors.ProjectRole}
            value={roleOption?.filter(
              (option) => option.value == Values?.ProjectRole?.RoleGroupId
            )}
            required
            native
          />
          <FormHelperText style={{ color: "red" }}>
            {Errors.ProjectRole}
          </FormHelperText>
        </Col>
        <Col lg={6}>
          <label className="SprintlabelStyle">
            In Percent%
            <label className="createAlert">*</label>
          </label>{" "}
          <Input
            placeholder="Please Enter Percentage"
            className="SprintFormFields"
            style={{ width: "100%", borderRadius: 8 }}
            variant="outlined"
            name="AllocPercentage"
            size="small"
            type="number"
            value={Values.AllocPercentage}
            onChange={(e) => handleInputChange(e, "AllocPercentage")}
            // error={Errors.AllocPercentage}
            // helperText={Errors.AllocPercentage}
            autoComplete="off"
            required
          />
          <FormHelperText style={{ color: "red" }}>
            {Errors.AllocPercentage}
          </FormHelperText>
        </Col>
      </Row> */}
      <Row className="mb-4">
        <Col lg={6}>
          <label className="SprintlabelStyle">
            Access From
            <label className="createAlert">*</label>
          </label>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              style={{ width: "100%" }}
              disablePast={!edit}
              varient="dialog"
              format="dd/MM/yyyy"
              // margin="normal"
              views={["year", "month", "date"]}
              // label="Allocation Start Date"
              // className="select MuiFormControl-marginNormal"
              value={Values.ProjectStartDate}
              error={Errors.ProjectStartDate}
              onChange={(date) =>
                DateInputChange(convertToPara("ProjectStartDate", date))
              }
            />
          </MuiPickersUtilsProvider>
          <FormHelperText style={{ color: "red" }}>
            {Errors.ProjectStartDate}
          </FormHelperText>
        </Col>
        <Col lg={6}>
          <label className="SprintlabelStyle">
            Access To
            <label className="createAlert">*</label>
          </label>{" "}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              style={{ width: "100%" }}
              disablePast={!edit}
              varient="dialog"
              format="dd/MM/yyyy"
              // margin="normal"
              views={["year", "month", "date"]}
              // label=" Allocation End Date"
              className="select"
              value={Values.ProjectEndDate}
              onChange={(date) =>
                DateInputChange(convertToPara("ProjectEndDate", date))
              }
            />
          </MuiPickersUtilsProvider>
        </Col>
      </Row>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "right",
          marginTop: 15,
        }}
      >
        <Button
          onClick={closeaccess}
          style={{
            fontSize: 14,
            padding: 9,
            width: 100,
            height: 40,
            borderRadius: 8,
            marginRight: 14,
            border: "2px solid #5250E5",
            backgroundColor: "#fff",
            color: "#5250E5",
            textAlign: "center",
            textTransform: "none",
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          onClick={(e) => {
            addAllocationHandler(e);
          }}
          disabled={checkSubmit}
          style={{
            fontSize: 14,
            padding: 9,
            width: 100,
            height: 40,
            borderRadius: 8,
            backgroundColor: "#5250E5",
            color: "#fff",
            // border: "0px solid #5A88F1",
            textAlign: "center",
            textTransform: "none",
          }}
        >
          {checkSubmit ? (
            <span
              className="spinner-border"
              role="status"
              aria-hidden="true"
              style={{ color: "#fff", width: "1.5rem", height: "1.5rem" }}
            ></span>
          ) : (
            "Submit"
          )}
        </Button>
      </div>
      {/* {allocatedEmployee === null || Values.TeamMemberId == "" ? (
        ""
      ) : Values.TeamMemberId.length === 1 ? (
        <div style={{ marginTop: "5%" }}>
          {/* {MultiValues.length > 0 ?
            MultiValues.map((e) => {
              return (<> */} 
              {console.log(allocatedEmployee,"allocatedemployee")}
      {allocatedEmployee && (
<Allocationaccesstabel
  managers={managers}
  test={test}
  managerdropdown={managerdropdown}
  projects={projectdetails}
  employee={employee}
  valueOfTeamMemberId={Values.TeamMemberId}
  role={Values.ProjectRole}
  valueOfProjectCode={Values.ProjectCode}
  allocatedEmployee={allocatedEmployee?.filter((e) => e.ProjectRole?.RoleCode === "SM")}
  visible={visible}
  setVisible={setVisible}
  loadData={loadData}
  Values={Values}
  setValues={setValues}
  edit={edit}
  setEdit={setEdit}
  projectMappingId={projectMappingId}
  setProjectMappingId={setProjectMappingId}
  initialValue={intialValue}
  setRefesh={setRefesh}
/>
  )}

          {/* </>) */}
        {/* </div>
      ) : (
        ""
      )} */}
    </div>
  );
}
